import { Link } from "@components/ui-kit";
import { t } from "@lingui/macro";
import type { FunctionComponent } from "react";

type LinkToTableProps = {
  onClick?: () => void;
};
export const LinkToTable: FunctionComponent<LinkToTableProps> = ({
  onClick,
}) => {
  return (
    <Link
      href={{ pathname: "/notifications" }}
      onClick={() => onClick?.()}
    >{t`View all notifications`}</Link>
  );
};
